import React, { useState } from "react";
import "./Education-Policies.css";

import Footer from "../components/Footer";
import Navbar from "../components/navbar";
import CTAButtons from "../components/sticky-button";
import PageHeader from "./PageHeader";
import ContactAdmissionsStrip from "../components/ContactAdmissionsStrip";
import BrochureForm from "../components/EnquiryForm";

const EducationalPolicy = () => {
  const [showForm, setShowForm] = useState(false);

  return (
    <>
      <Navbar setShowForm={setShowForm} />
      {showForm && <BrochureForm setShowForm={setShowForm} />}
      <CTAButtons />

      <div className="eo-page">
        <PageHeader
          title="Educational Organization Policy"
          crumbs={[
            { label: "Home", href: "/" }, 
            { label: "Educational Organization Policy" }
          ]}
        />
        
        <main className="eo-container eo-main">
          <div className="eo-section">
            
            {/* Core Policy Statement Paragraph */}
            <p className="eo-text">
              We, at Thakur Institute of Management Studies, Career Development
              &amp; Research are committed to offer excellence in software
              education, in inclusive and conducive academic environment for
              holistic development of our students. We work as a team and
              interact with students in pro-active manner to achieve our
              Educational Organization Objectives and fulfill all academic,
              statutory and regulatory requirements. We strive for continual
              improvement of our Educational Organizations Management System.
            </p>

            {/* Separator Wrapper Container to completely break away from paragraph layout flow */}
            <div className="eo-card-spacing-wrapper">
              
              <div className="eo-card">
            <div className="eo-card-image">
  <img
    src="/images/About/about.png"
    alt="TIMSCDR campus building"
  />
</div>

                <div className="eo-card-content">
                  <div className="eo-card-header">
                    <span className="eo-card-icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="6" stroke="currentColor" strokeWidth="1.8" />
                        <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8" />
                        <path d="M16.5 7.5L11 13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                        <path d="M17.5 6.5L20 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                        <path d="M20 4L16 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                      </svg>
                    </span>

                    <div className="eo-card-title-wrapper">
                      <h3 className="eo-card-title">Strategic Plan</h3>
                      <span className="eo-card-title-underline" />
                    </div>
                  </div>

                  <ol className="eo-card-list">
                    <li>Continual improvement in all Institutional processes</li>
                    <li>
                      Develop conducive academic environment to inculcate global
                      competencies among students.
                    </li>
                    <li>Promote culture of research and entrepreneurship</li>
                    <li>
                      Enhance Industry–Institute interaction via collaboration with
                      National &amp; International organizations.
                    </li>
                    <li>Develop socially conscientious students.</li>
                  </ol>
                </div>
              </div>

            </div> {/* /eo-card-spacing-wrapper */}
            
          </div>
        </main>
      </div>
      <ContactAdmissionsStrip onAppointmentClick={() => setShowForm(true)} />
      <Footer />
    </>
  );
};

export default EducationalPolicy;
